/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

// export const ON_CALL_UPLOAD = 'boilerplate/Landing/ON_CALL_UPLOAD'
export const LOADER_STATUS = 'DATA_ANALYTICS/LOADER_STATUS'
export const PROFILE_INFO = 'DATA_ANALYTICS/PROFILE_INFO';
export const SET_CHART_1 = 'DATA_ANALYTICS/SET_CHART_1';
export const SET_CHART_2 = 'DATA_ANALYTICS/SET_CHART_2';
export const SET_CHART_3 = 'DATA_ANALYTICS/SET_CHART_3';
export const SET_CHART_4 = 'DATA_ANALYTICS/SET_CHART_4';
export const SET_CHART_5 = 'DATA_ANALYTICS/SET_CHART_5';
export const SET_CHART_6 = 'DATA_ANALYTICS/SET_CHART_6';
export const SET_CHART_7 = 'DATA_ANALYTICS/SET_CHART_7';
export const SET_CHART_8 = 'DATA_ANALYTICS/SET_CHART_8';
export const DATA_FETCH_CASH_ITC  = "DATA_FETCH/CASH_ITC";
export const ON_NOTIFY = 'boilerplate/DATA_FETCH/ON_NOTIFY'